import { Routes } from '@angular/router';

import { AppLayoutComponent } from '@layout/app-layout.component';

import { LoggedInGuard } from '@shared/guards';
import { UserRole } from '@shared/models';

import { NotFoundComponent } from './auth/components';

export const appRoutes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./landing/landing.routes').then((m) => m.landingRoutes),
  },
  { path: 'notfound', component: NotFoundComponent, data: { breadcrumb: 'layout.menu.notFound' } },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  { path: 'register', redirectTo: 'auth/register' }, // INFO (Denis) - legacy URL, keep it alive
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./legal/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./legal/terms-of-use/terms-of-use.component').then((m) => m.TermsOfUseComponent),
  },
  {
    path: 'display',
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./display/display.routes').then((m) => m.displayRoutes),
  },
  {
    path: 'app',
    component: AppLayoutComponent,
    canActivate: [LoggedInGuard],
    data: { roles: [UserRole.Admin, UserRole.CompanyAdmin, UserRole.Manager] },
    children: [
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes),
        canActivate: [LoggedInGuard],
        data: { roles: [UserRole.Admin] },
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.settingsRoutes),
        data: {
          roles: [UserRole.Admin, UserRole.CompanyAdmin, UserRole.Manager],
        },
      },
      {
        path: '',
        loadChildren: () => import('./company/company.routes').then((m) => m.companyRoutes),
        data: { roles: [UserRole.Admin, UserRole.CompanyAdmin, UserRole.Manager] },
      },
      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  { path: '**', redirectTo: '/auth' },
];
